import Thing from './Thing'

/**
 * Defines a word in a thesaurus.
 * @memberOf things
 */
class Word extends Thing
{
    /**
     * Creates a new Word instance.
     * @constructor
     * @param object The generic object to initialize the object the first time.
     */
    constructor( object = null )
    {
        super( object ) ;
    }

    /**
     * A background color value option.
     * @type {string}
     */
    bgColor ;

    /**
     * A color value option.
     * @type {string}
     */
    color ;

    /**
     * The pattern to validate this word expression.
     * @type {string}
     */
    pattern ;

    /**
     * Clear the object.
     * @return {Object} The current item reference.
     */
    clear()
    {
        super.clear() ;
        this.bgColor = null ;
        this.color   = null ;
        this.pattern = null ;
        return this ;
    }

    /**
     * Returns a shallow copy of the object.
     * @return {Thing} a shallow copy of the object.
     */
    clone()
    {
        return new Word( this.toObject() ) ;
    }

    /**
     * Returns the generic object representation of the item.
     * @return {Object} The generic object representation of the item.
     */
    toObject()
    {
        return { ...super.toObject() , ...{
            bgColor : this.bgColor,
            color   : this.color,
            pattern : this.pattern
        }}
    }
}

export default Word ;


// WEBPACK FOOTER //
// ./src/app/things/Word.js